import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { ProdComponent } from '../prod/prod.component';
import { ProductService } from 'src/app/services/api/product/product.service';

@Component({
  selector: 'app-alert-recovery-order-changes',
  templateUrl: './alert-recovery-order-changes.component.html',
  styleUrls: ['./alert-recovery-order-changes.component.css']
})

export class AlertRecoveryOrderChangesComponent implements OnInit {

  missingProds: any[];
  differentPriceProds: any[];

  categories$: any[];

  innerHeight: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialogRef: MatDialogRef<AlertRecoveryOrderChangesComponent>,
    private MediaObserver: MediaObserver,
    private dialog: MatDialog,
    public ProductService: ProductService
  ) {
    this.missingProds = data.changes.missingProds;

    this.differentPriceProds = data.changes.differentPriceProds;
    this.categories$ = data.categories;
  }

  ngOnInit() { }

  closeDial() {
    this.dialogRef.close();
  }

  openProdDial(prod: any, from: string, index?: number|any): void {
  
    const myConf = new MatDialogConfig();

    if (this.MediaObserver.isActive("xs")) {
      myConf.panelClass = "full-screen"
    } else {
      myConf.width = (prod.product_type === 2) ? "780px" : "450px";
    }

    myConf.autoFocus = false;
    myConf.data = {
      index: index,
      from: from,
      prod: prod,
      categories: this.categories$
    };
 
    // this.ProductService.setObserProductTypeformule(prod.product_type == 2?true:false);
    const myDial = this.dialog.open(ProdComponent, myConf);

    myDial.afterClosed().subscribe((result) => {

      if (result) {

        this.missingProds.splice(index, 1);

        if (this.missingProds.length < 1) {

          this.closeDial();

        }

      }

    });

  }

}
